import styled from "styled-components";

import {
  actionListSubtitle,
  sectionTitle,
} from "../../shared/styles/typography";

export { Container, Main } from "../../styles/adminPage";

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin-bottom: 2.4rem;
`;

export const Legend = styled.legend`
  ${sectionTitle}
  margin-bottom: 1.6rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  width: 100%;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;
  padding-top: 1.6rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  margin-top: 2.4rem;

  p {
    display: flex;
    align-items: center;
    gap: 1rem;
    ${actionListSubtitle}
    margin: 0;
  }
`;

export const BoxOp = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin: 1.2rem 0;
`;

export const InputCheckBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  .radio {
    width: 1.6rem;
    height: 1.6rem;
    accent-color: ${({ theme }) => theme.colors.primary};
    flex-shrink: 0;
  }

  .ant-form-item {
    margin-bottom: 0;
    flex: 1;
  }
`;
